import { getConfig } from './ConfigClient'
import { Main } from './main'
import Logger from './Log'
import { onLoad } from './domload'

const Log = Logger.for('Index')

export function run (localConfig) {
  const context = document.currentScript

  Log.debug('SmartRTB Super Unit ' + localConfig.zone_id)

  onLoad(() => {
    Log.debug('Initial domload')
    getConfig(localConfig).then(config => {
      const main = new Main(config, context)
      main.run()
    }).catch(err => {
      Log.warn('Failed running tag: ' + err)
    })
  })
}
